<div class="main-content py-2 px-0 px-lg-2">
  <div class="section-menu-items">
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['carrier-promotions']"
      routerLinkActive="router-link-active"
    >
      <span translate class="translate">pages.newRetailer.carrierPromotions</span>
      <mat-icon class="ms-2">campaign</mat-icon>
    </button>
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['ocassion-rewards']"
      routerLinkActive="router-link-active"
      *hideIfUnauthorized="'OccasionRewards'"
    >
      <span translate class="translate">pages.newRetailer.occasionRewards</span>
      <mat-icon class="ms-2">local_activity</mat-icon>
    </button>
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['loyalty-config']"
      routerLinkActive="router-link-active"
      *hideIfUnauthorized="'LoyaltyPoints'"
    >
      <span translate class="translate">pages.newRetailer.loyaltyPoints</span>
      <mat-icon class="ms-2">redeem</mat-icon>
    </button>
    <button
    mat-flat-button
    class="item-each"
    [routerLink]="['banner-config']"
    routerLinkActive="router-link-active"
    *hideIfUnauthorized="'LoyaltyPoints'"
  >
    <span translate class="translate">Banner Configuration</span>
    <mat-icon class="ms-2">filter_vintage </mat-icon>
  </button>
    <button
    mat-flat-button
    class="item-each"
    [routerLink]="['video-config']"
    routerLinkActive="router-link-active"
    *hideIfUnauthorized="'LoyaltyPoints'"
  >

    <span translate class="translate">Videos</span>
    <mat-icon class="ms-2">play_circle</mat-icon>
  </button>
  <button
    mat-flat-button
    class="item-each"
    [routerLink]="['retailer-banner']"
    routerLinkActive="router-link-active"
    *hideIfUnauthorized="'LoyaltyPoints'"
  >
    <span translate class="translate">Retailer Mapping</span>
    <mat-icon class="ms-2">art_track</mat-icon>
  </button>
  </div>
  <router-outlet></router-outlet>
</div>
